import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { Production_CertificateDetailsOutputInput } from '../medical-certificate-drawer';
import ToastErrorMessage from '@components/toast/ToastErrorMessage';
import { getError } from '@utils/graph-utils';
import ListingTable from '@components/table/ListingTable';
import { summaryPopupHeaders } from '../medical-group-certificate-table';
import EnhancedButton from '@components/button/EnhancedButton';
import {
  getCertificateDetailsOutputInput,
  mapToMedicalGroupPolicyListingData,
} from './utils';
import { generateMedicalGroupCertificateOutput } from './queries';
import { IAbstractRecord } from '@models';

interface IPolicyCertficateMarineGroupSummaryDialogProps {
  data: Production_CertificateDetailsOutputInput;
  entityId: string;
  planDetails: IAbstractRecord;
  onClose: () => void;
  onSuccess: () => void;
}

const useStyles = makeStyles()(() => ({
  buttonsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignContent: 'center',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '15px',
    paddingTop: '1em',
  },
}));

const PolicyCertficateMedicalGroupSummaryDialog: React.FC<
  IPolicyCertficateMarineGroupSummaryDialogProps
> = ({ data, entityId, planDetails, onClose = () => undefined, onSuccess }) => {
  const { classes } = useStyles();

  const [submitting, setSubmitting] = useState<boolean>(false);
  const tableData = mapToMedicalGroupPolicyListingData(data, planDetails);

  const [generateOutput] = useMutation(generateMedicalGroupCertificateOutput());

  const submit = async () => {
    setSubmitting(true);

    try {
      const certificateDetailsOutputInput =
        getCertificateDetailsOutputInput(data);
      const variables = {
        entityId: entityId,
        certificateDetailsOutputInput,
      };

      const { errors } = await generateOutput({
        variables,
        errorPolicy: 'all',
      });

      if (!errors) {
        onSuccess();
      } else {
        toast.error(<ToastErrorMessage>{getError(errors)}</ToastErrorMessage>);
      }
    } catch (error) {
      toast.error(<ToastErrorMessage>{getError(error)}</ToastErrorMessage>);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <ListingTable
        disableSelection
        name={'table'}
        inlineTitle={'Certificates'}
        inline={true}
        headers={summaryPopupHeaders}
        data={tableData}
        actions={[]}
      />
      <div className={classes.buttonsContainer}>
        <EnhancedButton onClick={() => onClose()}>Cancel</EnhancedButton>
        <EnhancedButton
          state={submitting ? 'loading' : undefined}
          isPrimary
          onClick={() => submit()}
        >
          Submit
        </EnhancedButton>
      </div>
    </>
  );
};

export default PolicyCertficateMedicalGroupSummaryDialog;
